import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import { FirmModeProvider } from './contexts/FirmModeContext';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import LegalDiscussionPage from './pages/LegalDiscussionPage';
import ContactUsPage from './pages/ContactUsPage';
import ChatPage from './pages/ChatPage';
import ServicesPage from './pages/ServicesPage';
import ToolsPage from './pages/ToolsPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PricingPage from './pages/PricingPage';
import AdminDashboard from './pages/AdminDashboard';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import LandingPage from './pages/LandingPage';
import NewLoginPage from './pages/NewLoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import RouteTracker from './components/RouteTracker';
import './App.css';
import PleadingsPage from "./pages/PleadingsPage";
import FirmCasesPage from './pages/FirmCasesPage';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import FirmProtectedRoute from './components/FirmProtectedRoute';
import PaymentCheckoutPage from './pages/payments/PaymentCheckoutPage';


function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <FirmModeProvider>
        <Router>
          <RouteTracker />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/new-login" element={<NewLoginPage />} />

            <Route path="/home" element={
              <ProtectedRoute>
                <Layout>
                  <HomePage />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/disc" element={
              <ProtectedRoute>
                <Layout>
                  <LegalDiscussionPage />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/contact" element={
              <Layout>
                <ContactUsPage />
              </Layout>
            } />

            <Route path="/chat" element={
              <ProtectedRoute>
                <Layout>
                  <ChatPage />
                </Layout>
              </ProtectedRoute>
            } />

            {/* ✅ صفحة المرافعات */}
            <Route path="/pleadings" element={
              <ProtectedRoute>
                <Layout>
                  <PleadingsPage />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/services" element={
              <Layout>
                <ServicesPage />
              </Layout>
            } />

            <Route path="/tools" element={
              <Layout>
                <ToolsPage />
              </Layout>
            } />

            <Route path="/privacy-policy" element={
              <Layout>
                <PrivacyPolicy />
              </Layout>
            } />

            <Route path="/pricing" element={
              <Layout>
                <PricingPage />
              </Layout>
            } />

            <Route path="/payments/checkout/:paymentId" element={
              <ProtectedRoute>
                <Layout>
                  <PaymentCheckoutPage />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />

            <Route path="/admin/*" element={
              <AdminProtectedRoute>
                <Layout>
                  <AdminDashboard />
                </Layout>
              </AdminProtectedRoute>
            } />

            <Route path="/firm" element={
              <FirmProtectedRoute>
                <Layout>
                  <FirmCasesPage />
                </Layout>
              </FirmProtectedRoute>
            } />
          </Routes>
        </Router>
        </FirmModeProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
